import { type SvgProps, SvgWrapper } from '../utils';

export function ChevronLastIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M6.46973 5.46967C6.76262 5.17678 7.23738 5.17678 7.53027 5.46967L13.5303 11.4697C13.8232 11.7626 13.8232 12.2373 13.5303 12.5302L7.53027 18.5302C7.23738 18.8231 6.76262 18.8231 6.46973 18.5302C6.17683 18.2373 6.17683 17.7626 6.46973 17.4697L11.9395 11.9999L6.46973 6.53022C6.17683 6.23732 6.17683 5.76256 6.46973 5.46967Z" />
      <path d="M16.25 18V6C16.25 5.58579 16.5858 5.25 17 5.25C17.4142 5.25 17.75 5.58579 17.75 6V18C17.75 18.4142 17.4142 18.75 17 18.75C16.5858 18.75 16.25 18.4142 16.25 18Z" />
    </SvgWrapper>
  );
}
